// extracted by mini-css-extract-plugin
export var menuIcon = "_t6-0";
export var menuIconInline = "_t6-1";